import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsStepStatus, PmsStepStatus } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsStepStatus>
    useData={usePmsStepStatus}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
